import { InboxNotification, NotificationType } from '@/apis/business/notifications/types';
import BillingStartedIcon from '@/assets/icons/BillingStartedIcon';
import BusinessStatusIcon from '@/assets/icons/BusinessStatusIcon';
import IntegrationDisconnectedIcon from '@/assets/icons/IntegrationDisconnectedIcon';
import IntaofficeCreatedIcon from '@/assets/icons/IntraofficeCreatedIcon';
import LimitReachedNotificationIcon from '@/assets/icons/LimitReachedNotificationIcon';
// import OnboardingFormsIcon from '@/assets/icons/OnboardingFormsIcon';
import OnboardingFormSubmitIcon from '@/assets/icons/OnboardingFormSubmitIcon';
import RecommendationIcon from '@/assets/icons/RecommendationIcon';
import VoiceEngineCreatedIcon from '@/assets/icons/VoiceEngineCreatedIcon';
import VoiceEngineUpdatedIcon from '@/assets/icons/VoiceEngineUpdatedIcon';
import { Box } from '@mui/material';
import {
  MdCheckCircleOutline,
  MdErrorOutline,
  MdInfoOutline,
  MdLinkOff,
  MdPayment,
  MdSmartToy,
  MdWarningAmber
} from 'react-icons/md';

type Visual = { Icon: typeof MdInfoOutline; color: string };

const byType: Record<NotificationType, Visual> = {
  error: { Icon: MdErrorOutline, color: '#DA0808' },
  warning: { Icon: MdWarningAmber, color: '#EE9518' },
  success: { Icon: MdCheckCircleOutline, color: '#059669' },
  info: { Icon: MdInfoOutline, color: '#2563EB' }
};

const byEventKey: Record<string, Partial<Visual>> = {
  integration_disconnected: { Icon: MdLinkOff, color: '#DA0808' },
  integration_sync_failed: { Icon: MdLinkOff, color: '#DA0808' },
  payment_charge_failed: { Icon: MdPayment, color: '#DA0808' },
  agent_created: { Icon: MdSmartToy, color: '#2563EB' },
  recommendation: { Icon: RecommendationIcon, color: '#2563EB' },
  billing_started: { Icon: BillingStartedIcon, color: '#059669' },
  integration_connected: { Icon: IntegrationDisconnectedIcon, color: '#059669' },
  integration_assigned_to_business: { Icon: IntegrationDisconnectedIcon, color: '#059669' },
  integration_unassigned_from_business: { Icon: MdLinkOff, color: '#DA0808' },
  onboarding_submitted: { Icon: OnboardingFormSubmitIcon, color: '#2563EB' },
  intraoffice_note_created: { Icon: IntaofficeCreatedIcon, color: '#2563EB' },
  intraoffice_note_updated: { Icon: IntaofficeCreatedIcon, color: '#2563EB' },
  managed_business_account_status: { Icon: BusinessStatusIcon, color: '#2563EB' },
  voice_engine_updated: { Icon: VoiceEngineUpdatedIcon, color: '#195EFF' },
  available_voice_engine_updated: { Icon: VoiceEngineUpdatedIcon, color: '#195EFF' },
  new_voice_engine_available: { Icon: VoiceEngineCreatedIcon, color: '#077F13' },
  onboarding_payment_received: { Icon: MdPayment, color: '#059669' },
  ai_call_minutes_limit_reached: { Icon: LimitReachedNotificationIcon, color: '#DA0808' },
  ai_warm_call_minutes_limit_reached: { Icon: LimitReachedNotificationIcon, color: '#DA0808' },
  ai_chat_messages_limit_reached: { Icon: LimitReachedNotificationIcon, color: '#DA0808' },
  sms_limit_reached: { Icon: LimitReachedNotificationIcon, color: '#DA0808' },
  storage_limit_reached: { Icon: LimitReachedNotificationIcon, color: '#DA0808' },
  workflows_limit_reached: { Icon: LimitReachedNotificationIcon, color: '#DA0808' }
};

export function getNotificationVisual(n: InboxNotification): Visual {
  const base = byType[n.notification_type] ?? byType.info;
  const extra = byEventKey[n.event_key];
  return {
    Icon: extra?.Icon ?? base.Icon,
    color: extra?.color ?? base.color
  };
}

export function NotificationRowIcon({ n }: { n: InboxNotification }) {
  const { Icon, color } = getNotificationVisual(n);
  return (
    <Box
      sx={{
        width: 36,
        height: 36,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      <Icon size={20} color={color} />
    </Box>
  );
}
